module.exports = __webpack_public_path__ + "static/media/应用图片2_03.b17d7016.png";